// Utilities für die Such-Formulare auf der Startseite und den Suchseiten
mp.search = {
    p: null, // dependency zu mp.content
    locationNanobar: null,
    locationNanobarTimeout: null,

    init: function () {
        $(document).on('keyup', '.mpFilterFilter', mp.search.filterFilter);
        $(document).on('click', '.mpFilterSortNumeric', mp.search.sortFilterNumeric);
        $(document).on('click', '.mpFilterSortAlphabet', mp.search.sortFilterAlphabet);

        $(document).on('click', '#mpSetLocationFromBrowser', mp.search.setLocationFromBrowser);

        if (navigator.geolocation) {
            $('#mpSetLocationFromBrowser').show();
            $('#mpEvent').on('contentxhr', function () {
                $('#mpSetLocationFromBrowser').show()
            });
        }

        if ($('#mpSearchResult').length > 0) {
            $(document).on('click', '#mpSearchFilterMobile', mp.search.mobileFilter);
        }

        if ($('#mpSearchForm').length > 0) {
            mp.search.initSearchForm();
        }

        // workaround für stacked modals in der mobilen Suche
        $(document).on('hidden.bs.modal', function () {
            if ($('#mpSearchModal').is(':visible')) {
                $('body').addClass('modal-open');
                $('#mpSearchModal').removeClass('mpFirstStackModal');
            }
        });
        $(document).on('shown.bs.modal', function (ev) {
            if ($('#mpSearchModal').is(':visible') && $(ev.target).attr('id') !== 'mpSearchModal') {
                $('#mpSearchModal').addClass('mpFirstStackModal');
            }
        });
        $(document).on('click', '.mpCloseSearchModal', mp.search.closeSearchModal);
    },

    filterFilter: function (ev) {
        ev.preventDefault();
        var ref = $(this).parents('.modal-content').find('.mpFilterList');

        var val = $(this).val();
        val = val.toLowerCase();

        if (val == '') {
            ref.find('a').addClass('d-flex').removeClass('d-none');
        } else {
            ref.find('a').addClass('d-none').removeClass('d-flex');
            ref.find('a[data-search*="' + $.escapeSelector(val) + '"]').addClass('d-flex').removeClass('d-none');
        }
    },

    sortFilterNumeric: function (ev) {
        ev.preventDefault();
        $(ev.target).tooltip('hide');
        $(ev.target).parents('.mpActions').find('.mpFilterSortAlphabet').removeClass('mpAlphabetSortAct').addClass('mpAlphabetSort');
        $(ev.target).removeClass('mpNumericSort').addClass('mpNumericSortAct');

        var ref = $(this).parents('.modal-content').find('.mpFilterList a');
        ref.tinysort({order: 'desc', data: 'sortcount'});

        return false;
    },

    sortFilterAlphabet: function (ev) {
        ev.preventDefault();
        $(ev.target).tooltip('hide');
        $(ev.target).parents('.mpActions').find('.mpFilterSortNumeric').removeClass('mpNumericSortAct').addClass('mpNumericSort');
        $(ev.target).removeClass('mpAlphabetSort').addClass('mpAlphabetSortAct');

        var ref = $(this).parents('.modal-content').find('.mpFilterList a');
        ref.tinysort(); // FIXME: Support für volle Character-Sets!

        return false;
    },

    initSearchForm: function () {
        mp.search.p = $('#mpSearchForm').parsley();

        /*$(document).on('keyup', '#mpSearchForm input', function () {
            var count = $('#mpSearchForm input[type="number"],#mpSearchForm input[type="text"]').filter(function () {
                return this.value != "";
            }).length;
            if (count > 0) {
                $('#mpApprox').show();
            } else {
                $('#mpApprox').hide();
            }
        });*/

        $(document).on('keyup', '#mpZip', function (ev) {
            if ($(this).val() != '') {
                $('#mpCircumcircleWrap').removeClass('d-none');
            } else {
                $('#mpCircumcircleWrap').addClass('d-none');
            }
        });

        // gespeicherte Suche
        // FIXME: Prototyp - soll später serverseitig laufen
        if (typeof (Cookies.get('MP_Search')) !== 'undefined' && Cookies.get('MP_Search') != '') {
            try {
                mp.content.loadWithPost($('#mpSearchForm').attr('action'), $.parseJSON(Cookies.get('MP_Search')), null);
            } catch (e) {
                //console.log(e);
            }
        }
    },

    mobileFilter: function () {
        if (mp.getViewport() == 'xs' || mp.getViewport() == 'sm') {
            if (typeof ($('#mpSearchModal').data('done')) === 'undefined') {
                $('#mpSearchModal').data('done', true);
                $('#mpSearchFilterBody .modal').appendTo('#mpSearchResult'); // alle modals verschieben
                var html = $($('#mpSearchFilterBody').clone());
                $('#mpSearchFilterBody').remove(); // wichtig für Form-Kontext!
                $('#mpSearchModal .modal-body').html(html.find('.select2').remove().end().html());
                try {
                    mp.select2.lazyLoadSelect2();
                } catch (e) {
                }
            }

            $('#mpSearchModal').modal('show');
        }
    },

    setLocationFromBrowser: function (ev) {
        ev.preventDefault();
        $('#mpSetLocationFromBrowser span').hide();

        mp.search.locationNanobar = new Nanobar({
            classname: 'mpNanobar',
            target: document.getElementById('mpSetLocationFromBrowser')
        });

        if (navigator.geolocation) {
            if (location.protocol === 'https:') {
                mp.search.locationNanobar.go(23);
                mp.search.locationNanobarTimeout = setTimeout(function () {
                    mp.search.locationNanobar.go(42);
                }, 1200);

                navigator.geolocation.getCurrentPosition(mp.search.browserPosition, mp.search.browserPositionError);
            } else {
                mp.search.browserPositionError();
                // INFO: für DEV-Test
                //mp.search.browserPosition({coords:{latitude:47.88124,longitude:11.7117813}});
            }
        }
    },
    browserPosition: function (position) {
        try {
            clearTimeout(mp.search.locationNanobarTimeout);
        } catch (e) {
        }
        mp.search.locationNanobar.go(100);

        if (typeof (position.coords.latitude) != 'undefined' && typeof (position.coords.longitude) != 'undefined') {
            mp.content.load($('#mpSetLocationFromBrowser').attr('href').replace('latlng', position.coords.latitude + ',' + position.coords.longitude), true);
        } else {
            $('#mpSetLocationFromBrowser span').last().show(); // Standardmeldung
        }
    },
    browserPositionError: function (error) {
        try {
            clearTimeout(mp.search.locationNanobarTimeout);
        } catch (e) {
        }
        mp.search.locationNanobar.go(100);

        $('#mpSetLocationFromBrowser span').hide();
        if (typeof (error) != 'undefined' && typeof (error.code) != 'undefined' && typeof (error.message) != 'undefined' && error.code !== 1) {
            $('#mpSetLocationFromBrowser span').first().html('<br>' + error.message).show();
        } else {
            $('#mpSetLocationFromBrowser span').last().show(); // Standardmeldung
        }
    },

    closeSearchModal: function () {
        $('#mpSearchModal').modal('hide');
        $(window).scrollTo('h1', 300);
    }
};

$(document).ready(function () {
    mp.search.init();
});
